import type { FC } from 'react'
import type { HeroImageProps } from './HeroImage'
import HeroImage from './HeroImage'

export type DynamicHeroImageProps = HeroImageProps

const DynamicHeroImage: FC<DynamicHeroImageProps> = ({ ...props }) => <HeroImage {...props} />

export default DynamicHeroImage
